const Line = () => {
  return <hr className="w-full h-[1px] border-[#9AA884]"></hr>;
};

export default Line;
